import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'underscore';

import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetLibraryService } from '../../services/widget-library.service';
import { AdKeyword, SemKeywordsV1Component } from '../sem-keywords-v1/sem-keywords-v1.component';

@Component({
	selector: 'app-sem-keywords-r10',
	styleUrls: ['./sem-keywords-r10.component.css'],
	templateUrl: './sem-keywords-r10.component.html'
})
export class SemKeywordsR10Component extends SemKeywordsV1Component implements OnInit {
	@Input() sectionclass: any;
	@Input() datatableconfig: any;
	public adGroups;
	public selectedAdGroupIndex: number = 0;
	public selectedAdGroupKeywords: any[] = null;
	public currentPageNum: number;
	public cssClasses: any = {
		pagerLeftArrow: '',
		pagerNext: 'datatable-last-text',
		pagerPrevious: 'datatable-first-text',
		pagerRightArrow: '',
		sortAscending: 'fa fa-long-arrow-up',
		sortDescending: 'fa fa-long-arrow-down'
	};
	public records: any;
	public tableColumns: any;
	public defaultSort: any;
	public tableOffset: number = 0;
	public tooltipOptions = {
		animation: 'fade',
		arrow: true,
		duration: 750,
		dynamicTitle: true,
		position: 'top',
		scale: 'big'
	};

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected widgetLibraryService: WidgetLibraryService
	) {
		super(analyticsService, analyticsDataModel, widgetLibraryService);
	}

	ngOnInit(): void {
		this.legend = JSON.parse(decodeURI(this.legend));
		super.ngOnInit();
		this.defaultSort = this.datatableconfig.sortBy ?? [];
	}

	setCutOffDate(): void {
		this.isGoliveNotStarted = this.analyticsService.isGoliveNotStarted;
		this.legend.forEach((legendObj) => {
			legendObj.enabled = true;
			if (legendObj.condition === 'cutofdate' && this.isGoliveNotStarted) {
				legendObj.enabled = false;
			}
		});
	}

	mapKeywordsDataToInterface(responseData: any[]): AdKeyword[] {
		const adKeywords: AdKeyword[] = [];
		for (const response of responseData) {
			const adKeyword: AdKeyword = {} as AdKeyword;
			adKeyword.adGroupId = response.adgroup_id;
			adKeyword.adGroupName = response.adgroup_name;
			adKeyword.keyword = response.keyword;
			adKeyword.impressions = UtilityService.isUndefinedOrNull(response.impressions)
				? null
				: parseFloat(response.impressions);
			adKeyword.preCutOffImpressions = UtilityService.isUndefinedOrNull(response.pre_cut_off_impressions)
				? null
				: parseFloat(response.pre_cut_off_impressions);
			adKeyword.clicks = UtilityService.isUndefinedOrNull(response.clicks) ? null : parseFloat(response.clicks);
			adKeyword.avgPosition = UtilityService.isUndefinedOrNull(response.avg_position)
				? null
				: parseFloat(response.avg_position);
			adKeyword.abs_top_impression_share = UtilityService.isUndefinedOrNull(response.abs_top_impression_share)
				? null
				: parseFloat(response.abs_top_impression_share);
			adKeyword.top_impression_share = UtilityService.isUndefinedOrNull(response.top_impression_share)
				? null
				: parseFloat(response.top_impression_share);
			adKeyword.weightedImpressions = adKeyword.preCutOffImpressions * adKeyword.avgPosition;
			adKeyword.totalAbsImpressions = adKeyword.impressions * adKeyword.abs_top_impression_share;
			adKeyword.totalTopImpressions = adKeyword.impressions * adKeyword.top_impression_share;
			adKeyword.ctr = UtilityService.isUndefinedOrNull(response.clicks)
				? null
				: response.ctr > 0
				? response.ctr
				: Number(response.ctr).toPrecision(3);
			adKeywords.push(adKeyword);
		}
		return adKeywords;
	}

	setRows(data: any[]): void {
		this.adGroups = _.sortBy(_.sortBy(_.sortBy(data, 'name').reverse(), 'impressions'), 'clicks').reverse();
		this.adGroups.forEach((adGroup, index) => {
			adGroup['adGroupIndex'] = index;
		});
		this.updateKeywords(0);
		this.currentPageNum = 1;
		this.tableOffset = 0;
	}

	updateKeywords(index: number): void {
		if (this.adGroups?.length) {
			this.selectedAdGroupIndex = index;
			this.defaultSort = [];
			this.selectedAdGroupKeywords = [];
			this.selectedAdGroupKeywords = this.adGroups.filter((adgroup) => adgroup.adGroupIndex === index)[0].keywords;
			this.tableOffset = 0;
			// reset data table sorting after data change
			setTimeout(() => {
				this.defaultSort = this.datatableconfig.sortBy ?? [];
				this.selectedAdGroupKeywords = _.sortBy(
					_.sortBy(_.sortBy(this.selectedAdGroupKeywords, 'keyword').reverse(), 'impressions'),
					'clicks'
				).reverse();
			});
		}
	}

	onPageChange(event: any): void {
		this.tableOffset = event.offset;
	}
}
